import React from "react";
import { useNavigate } from "react-router-dom";

const ZsmDashboard = () => {
  const navigate = useNavigate();

  // Demo data
  const zsmName = "ZSM Name";
  const zsmId = "ZSM1001";

  const totalAsm = 0;
  const totalSm = 1;
  const totalDealers = 201;

  return (
    <div className="container-fluid py-4">

      {/* HEADER */}

      <div className="row align-items-start mb-5">
        <div className="col">
          <h1 className="fw-bold mb-1">
            Dashboard
          </h1>

          <p className="text-secondary fs-5 mb-0">
            Welcome back, {zsmName}
          </p>
        </div>

        <div className="col-auto">
          <span className="badge bg-white text-primary border rounded-3 px-3 py-3 fs-6">
            {zsmId}
          </span>
        </div>
      </div>

      {/* QUICK ACTIONS */}

      <div className="row mb-5">
        <div className="col-12 mb-3">
          <h4 className="fw-bold mb-1">
            Quick Actions
          </h4>

          <p className="text-secondary mb-0">
            Manage your sales hierarchy
          </p>
        </div>

        {/* ADD ASM */}

        <div className="col-12 col-md-6 col-xl-4 mb-3">
          <div
            className="card border rounded-4 h-100"
            role="button"
            onClick={() => navigate("add-asm")}
          >
            <div className="card-body d-flex align-items-center p-3">
              <div className="bg-primary bg-opacity-10 rounded-4 d-flex align-items-center justify-content-center me-3 flex-shrink-0 p-3">
                <span className="text-primary fs-4">+</span>
              </div>

              <div>
                <h6 className="fw-bold mb-1">Add ASM</h6>
                <p className="text-secondary small mb-0">
                  Area Sales Manager
                </p>
              </div>
            </div>
          </div>
        </div>

        {/* ADD SM */}

        <div className="col-12 col-md-6 col-xl-4 mb-3">
          <div
            className="card border rounded-4 h-100"
            role="button"
            onClick={() => navigate("add-sm")}
          >
            <div className="card-body d-flex align-items-center p-3">
              <div className="bg-primary bg-opacity-10 rounded-4 d-flex align-items-center justify-content-center me-3 flex-shrink-0 p-3">
                <span className="text-primary fs-4">+</span>
              </div>

              <div>
                <h6 className="fw-bold mb-1">Add SM</h6>
                <p className="text-secondary small mb-0">
                  Sales Manager
                </p>
              </div>
            </div>
          </div>
        </div>

        {/* ADD DEALER */}

        <div className="col-12 col-md-6 col-xl-4 mb-3">
          <div
            className="card border rounded-4 h-100"
            role="button"
            onClick={() => navigate("add-dealer")}
          >
            <div className="card-body d-flex align-items-center p-3">
              <div className="bg-primary bg-opacity-10 rounded-4 d-flex align-items-center justify-content-center me-3 flex-shrink-0 p-3">
                <span className="text-primary fs-4">+</span>
              </div>

              <div>
                <h6 className="fw-bold mb-1">Add Dealer</h6>
                <p className="text-secondary small mb-0">
                  Dealer Management
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* OVERVIEW */}

      <div className="row mb-4">
        <div className="col-12 mb-2">
          <h4 className="fw-bold mb-1">
            Overview
          </h4>

          <p className="text-secondary small mb-0">
            Current active team members
          </p>
        </div>

        {/* TOTAL ASM */}

        <div className="col-12 col-sm-6 col-xl-4 mb-3">
          <div className="card border rounded-4 h-100">
            <div className="card-body d-flex align-items-center p-3">
              <div className="bg-success bg-opacity-10 rounded-3 d-flex align-items-center justify-content-center me-3 p-2">
                <span className="text-success fw-bold fs-5">A</span>
              </div>

              <div>
                <p className="text-secondary small mb-0">
                  Total ASM
                </p>
                <h4 className="fw-bold mb-0">{totalAsm}</h4>
              </div>
            </div>
          </div>
        </div>

        {/* TOTAL SM */}

        <div className="col-12 col-sm-6 col-xl-4 mb-3">
          <div className="card border rounded-4 h-100">
            <div className="card-body d-flex align-items-center p-3">
              <div className="bg-warning bg-opacity-10 rounded-3 d-flex align-items-center justify-content-center me-3 p-2">
                <span className="text-warning fw-bold fs-5">S</span>
              </div>

              <div>
                <p className="text-secondary small mb-0">
                  Total SM
                </p>
                <h4 className="fw-bold mb-0">{totalSm}</h4>
              </div>
            </div>
          </div>
        </div>

        {/* TOTAL DEALERS */}

        <div className="col-12 col-sm-6 col-xl-4 mb-3">
          <div className="card border rounded-4 h-100">
            <div className="card-body d-flex align-items-center p-3">
              <div className="bg-info bg-opacity-10 rounded-3 d-flex align-items-center justify-content-center me-3 p-2">
                <span className="text-info fw-bold fs-5">D</span>
              </div>

              <div>
                <p className="text-secondary small mb-0">
                  Total Dealers
                </p>
                <h4 className="fw-bold mb-0">{totalDealers}</h4>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* ZSM INFORMATION */}

      <div className="row">
        <div className="col-12">
          <div className="card border rounded-4">
            <div className="card-body p-4">
              <div className="row align-items-center">

                {/* LOGGED IN ZSM */}

                <div className="col-12 col-md-4 mb-3 mb-md-0">
                  <p className="text-secondary mb-1">
                    Logged-in ZSM
                  </p>
                  <h5 className="fw-bold mb-0">
                    {zsmName}
                  </h5>
                </div>

                {/* ZSM ID */}

                <div className="col-12 col-md-4 mb-3 mb-md-0">
                  <p className="text-secondary mb-1">
                    ZSM ID
                  </p>
                  <h5 className="fw-bold mb-0">
                    {zsmId}
                  </h5>
                </div>

                {/* ACCOUNT */}

                <div className="col-12 col-md-4">
                  <p className="text-secondary mb-1">
                    Account
                  </p>
                  <h5 className="fw-bold text-success mb-0">
                    Active
                  </h5>
                </div>

              </div>
            </div>
          </div>
        </div>
      </div>

    </div>
  );
};

export default ZsmDashboard;